/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Withattempt1Inputs */

const zh_print_withattempt1 = /** @type {(inputs: Print_Withattempt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印此次作答`)
};

const en_print_withattempt1 = /** @type {(inputs: Print_Withattempt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print This Attempt`)
};

const es_print_withattempt1 = /** @type {(inputs: Print_Withattempt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir este intento`)
};

/**
* | output |
* | --- |
* | "Print This Attempt" |
*
* @param {Print_Withattempt1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const print_withattempt1 = /** @type {((inputs?: Print_Withattempt1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Withattempt1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_withattempt1(inputs)
	if (locale === "en") return en_print_withattempt1(inputs)
	return es_print_withattempt1(inputs)
});
export { print_withattempt1 as "print_withAttempt" }